// import { GET_SCHEDULE_SURGERY_DETAILS } from "src/pages/scheduleSurgery/redux/actions";

export const SET_SURGERY_DETAILS = 'CONSIGNMENT: SET_SURGERY_DETAILS';
export const SET_CART_DATA = 'SURGERY: SET_CART_DATA';
export const UPDATE_CART_DATA = 'CONSIGNMENT: UPDATE_CART_QUANTITY';
export const UPDATE_CART_DATA_SHIPPING = 'SURGERY: UPDATE_CART_DATA_SHIPPING';
export const SET_SHIPPING_DETAILS = 'SURGERY: SET_SHIPPING_DETAILS';
export const SET_SHIPPING_DETAILS_EDIT_MODE = 'SET_SHIPPING_DETAILS_EDIT_MODE';
export const GET_DROPDOWN = 'CONSIGNMENT: GET_DROPDOWN';
export const GET_DROPDOWN_SUCCESS = 'CONSIGNMENT: GET_DROPDOWN_SUCCESS';
export const GET_DROPDOWN_FAILURE = 'CONSIGNMENT: GET_DROPDOWN_FAILURE';
export const GET_INVENTORY_CHECKED_ITEMS =
    'CONSIGNMENT:GET_INVENTORY_CHECKED_ITEMS';
export const SAVE_SURGERY_DETAILS = 'SURGERY: SAVE_SURGERY_DETAILS';
export const SAVE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: SAVE_SURGERY_DETAILS_SUCCESS';
export const SAVE_SURGERY_DETAILS_FAILURE =
    'SURGERY: SAVE_SURGERY_DETAILS_FAILURE';
export const UPDATE_SURGERY_DETAILS = 'SURGERY: UPDATE_SURGERY_DETAILS';
export const UPDATE_SURGERY_DETAILS_SUCCESS =
    'SURGERY: UPDATE_SURGERY_DETAILS_SUCCESS';
export const UPDATE_SURGERY_DETAILS_FAILURE =
    'SURGERY: UPDATE_SURGERY_DETAILS_FAILURE';

export const GET_PRODUCTS = 'EQUITYPRODUCTS:GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'EQUITYPRODUCTS:GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'EQUITYPRODUCTS:GET_PRODUCTS_FAILURE';
export const GET_PRODUCTS_BULK = 'EQUITYPRODUCTS:GET_PRODUCTS_BULK';
export const GET_PRODUCTS_BULK_SUCCESS =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_SUCCESS';
export const GET_PRODUCTS_BULK_FAILURE =
    'EQUITYPRODUCTS:GET_PRODUCTS_BULK_FAILURE';
export const SET_PRODUCTS = 'EQUITYPRODUCTS:SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'EQUITYPRODUCTS:CLEAR_PRODUCTS';
export const GET_PRODUCTSGUIDE = 'PRODUCTSGUIDE:GET_PRODUCTSGUIDE';
export const GET_PRODUCTSGUIDE_SUCCESS =
    'PRODUCTSGUIDE:GET_PRODUCTSGUIDE_SUCCESS';
export const GET_PRODUCTSGUIDE_FAILURE =
    'PRODUCTSGUIDE:GET_PRODUCTSGUIDE_FAILURE';
export const SET_PRODUCTSGUIDE = 'PRODUCTSGUIDE:SET_PRODUCTSGUIDE';
export const CLEAR_PRODUCTS_GUIDE = 'PRODUCTSGUIDE:CLEAR_PRODUCTS_GUIDE';
export const VALIDATE_PRODUCTS = 'EQUITYPRODUCTS:VALIDATE_PRODUCTS';
export const VALIDATE_PRODUCTS_SUCCESS =
    'EQUITYPRODUCTS:VALIDATE_PRODUCTS_SUCCESS';
export const VALIDATE_PRODUCTS_FAILURE =
    'EQUITYPRODUCTS: VALIDATE_PRODUCTS_FAILURE';
export const CLEAR_VALIDATED_PRODUCTS =
    'EQUITYPRODUCTS: CLEAR_VALIDATED_PRODUCTS';
export const GET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER';
export const GET_PRODUCTSTEMPLATESFILTER_SUCCESS =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_SUCCESS';
export const GET_PRODUCTSTEMPLATESFILTER_FAILURE =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_FAILURE';
export const SET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:SET_PRODUCTSTEMPLATESFILTER';
export const SET_PROGRESS_BAR_STATUS =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_STATUS';
export const RESET_PROGRESS_BAR_STATUS =
    'CONSIGNMENTPROGRESSBAR: RESET_PROGRESS_BAR_STATUS';
export const SET_PROGRESS_BAR_CURRENT_STEP =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_CURRENT_STEP';
export const SET_PROGRESS_BAR_EDIT_MODE =
    'CONSIGNMENTPROGRESSBAR: SET_PROGRESS_BAR_EDIT_MODE';

export const SET_PRICING_NOTES = 'SET_PRICING_NOTES';
// product details

export const GET_PRODUCT_DETAILS = 'EQUITYPRODUCTS: GET_PRODUCT_DETAILS';
export const GET_PRODUCT_DETAILS_SUCCESS =
    'EQUITYPRODUCTS: GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_ERROR =
    'EQUITYPRODUCTS: GET_PRODUCT_DETAILS_ERROR';
export const SORT_PRODUCT_DETAILS = 'EQUITYPRODUCTS: SORT_PRODUCT_DETAILS';
export const GET_SHIPPING_METHODS = 'CONSIGNMENTSHIPPING: GET_SHIPPING_METHODS';
export const GET_SHIPPING_METHODS_SUCCESS =
    'CONSIGNMENTSHIPPING: GET_SHIPPING_METHODS_SUCCESS';
export const GET_SHIPPING_METHODS_FAILURE =
    'CONSIGNMENTSHIPPING: GET_SHIPPING_METHODS_FAILURE';
export const SET_SHIP_TO_ADDRESS_DETAILS =
    'SHIPPING: SET_SHIP_TO_ADDRESS_DETAILS';
export const GET_SHIP_TO_ADDRESS =
    'CONSIGNMENTBILLINGSHIPPING: GET_SHIP_TO_ADDRESS';
export const GET_SHIP_TO_ADDRESS_SUCCESS =
    'CONSIGNMENTBILLINGSHIPPING: GET_SHIP_TO_ADDRESS_SUCCESS';
export const GET_SHIP_TO_ADDRESS_FAILURE =
    'CONSIGNMENTBILLINGSHIPPING: GET_SHIP_TO_ADDRESS_FAILURE';

export const GET_BATCH_ALLOCATIONS = 'SHIPPING: GET_BATCH_ALLOCATIONS';
export const GET_BATCH_ALLOCATIONS_SUCCESS =
    'SHIPPING: GET_BATCH_ALLOCATIONS_SUCCESS';
export const GET_BATCH_ALLOCATIONS_FAILURE =
    'SHIPPING: GET_BATCH_ALLOCATIONS_FAILURE';

export const SET_VISUALIZATION_INSPECTION =
    'CONSIGNMENTSUBMIT: SET_VISUALIZATION_INSPECTION';
// Surgery Notes
export const HANDLE_SURGERY_NOTES = 'HANDLE_SURGERY_NOTES';
export const GET_SURGERY_DETAILS = 'GET_SURGERY_DETAILS';
export const GET_SURGERY_DETAILS_SUCCESS = 'GET_SURGERY_DETAILS_SUCCESS';
export const GET_SURGERY_DETAILS_FAILURE = 'GET_SURGERY_DETAILS_FAILURE';
export const RESET_SURGERY_DETAILS = 'CONSIGNMENT: RESET_SURGERY_DETAILS';
export const CHANGE_SHIPPING_SEGMENT_INDEX = 'CHANGE_SHIPPING_SEGMENT_INDEX';
export const CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT =
    'CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT';
export const DISABLE_SURGERY_DATE = 'DISABLE_SURGERY_DATE';
export const CURRENT_SURGERY_DATE_SELECTED = 'CURRENT_SURGERY_DATE_SELECTED';
export const CHANGE_ACKNOWLEGMENT_VIEW = 'CHANGE_ACKNOWLEGMENT_VIEW';

// category data
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE =
    'GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE';
// approach and technology
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE =
    'GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE';
// export const SET_UNSAVED_CHANGES_POP_UP = 'SS:SET_UNSAVED_CHANGES_POP_UP';
export const SET_SCHEDULE_SURGERY_CU_IN_PROGRESS =
    'SS:SET_SCHEDULE_SURGERY_CU_IN_PROGRESS';
export const PHYSICIAN_LOAD_ALL_LOADING =
    'CONSIGNMENT:PHYSICIAN_LOAD_ALL_LOADING';
export const SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP =
    'SS:SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP';

// set recently used PhysicianS
export const PUT_RECENTLY_USED_PHYSICIANS = 'PUT_RECENTLY_USED_PHYSICIANS';
export const PUT_RECENTLY_USED_PHYSICIANS_SUCCESS =
    'PUT_RECENTLY_USED_PHYSICIANS_SUCCESS';
export const PUT_RECENTLY_USED_PHYSICIANS_FAILURE =
    'PUT_RECENTLY_USED_PHYSICIANS_FAILURE';

// get detailed templates list
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST =
    'CONSIGNMENT: GET_DETAILED_PRODUCT_TEMPLATE_LIST';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS =
    'CONSIGNMENT: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE =
    'CONSIGNMENT: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE';

// get template details with template id
export const GET_TEMPLATE_DETAILS = 'CONSIGNMENT: GET_TEMPLATE_DETAILS';
export const GET_TEMPLATE_DETAILS_SUCCESS =
    'CONSIGNMENT: GET_TEMPLATE_DETAILS_SUCCESS';
export const GET_TEMPLATE_DETAILS_FAILURE =
    'CONSIGNMENT: GET_TEMPLATE_DETAILS_FAILURE';

// create template
export const CREATE_PRODUCT_TEMPLATE = 'CONSIGNMENT: CREATE_PRODUCT_TEMPLATE';
export const CREATE_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENT: CREATE_PRODUCT_TEMPLATE_SUCCESS';
export const CREATE_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENT: CREATE_PRODUCT_TEMPLATE_FAILURE';

// update product template
export const UPDATE_PRODUCT_TEMPLATE = 'CONSIGNMENT: UPDATE_PRODUCT_TEMPLATE';
export const UPDATE_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENT: UPDATE_PRODUCT_TEMPLATE_SUCCESS';
export const UPDATE_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENT: UPDATE_PRODUCT_TEMPLATE_FAILURE';
// product template
export const GET_DATA_FOR_PRODUCT_TEMPLATE =
    'CONSIGNMENT: GET_DATA_FOR_PRODUCT_TEMPLATE';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENT: GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENT: GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE';

export const RESET_CREATE_TEMPLATE = 'CONSIGNMENT: RESET_CREATE_TEMPLATE';

// Update Template filter refine data (listing)
export const SET_PRODUCT_TEMPLATE_REFINE_DATA =
    'CONSIGNMENT: SET_PRODUCT_TEMPLATE_REFINE_DATA';
export const SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST =
    'CONSIGNMENT: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST';

export const CLEAR_SPECFIC_DROPDOWN_LIST =
    'CONSIGNMENT:CLEAR_SPECFIC_DROPDOWN_LIST';
export const RESET_CONSIGNMENT_DETAILS = 'RESET_CONSIGNMENT_DETAILS';
export const RESET_PRICEOVERRIDE_DATA = 'RESET_PRICEOVERRIDE_DATA';
export const GET_HOLIDAY_LIST = 'GET_HOLIDAY_LIST';
export const GET_HOLIDAY_LIST_SUCCESS = 'GET_HOLIDAY_LIST_SUCCESS';
export const SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS =
    'SET_HOLIDAY_LIST_AND_CALCULATE_LAST_THREE_BUSINESS_DAYS';
export const GET_HOLIDAY_LIST_ERROR = 'GET_HOLIDAY_LIST_ERROR';
export const CLEAR_SHIPPING_ADDRESS = 'CLEAR_SHIPPING_ADDRESS';
export const RESET_CREATE_UPDATE_SURGERY = 'RESET_CREATE_UPDATE_SURGERY';
export const SET_EXPANDED_FILTER_VIEW = 'SET_EXPANDED_FILTER_VIEW';
export const GET_EQUITY_DETAILS = 'EQUITY: GET_EQUITY_DETAILS';
export const GET_EQUITY_DETAILS_SUCCESS = 'EQUITY: GET_EQUITY_DETAILS_SUCCESS';
export const GET_EQUITY_DETAILS_FAILURE = 'EQUITY: GET_EQUITY_DETAILS_FAILURE';
export const SAVE_EQUITY_DETAILS = 'EQUITY: SAVE_EQUITY_DETAILS';
export const SAVE_EQUITY_DETAILS_SUCCESS =
    'EQUITY: SAVE_EQUITY_DETAILS_SUCCESS';
export const SAVE_EQUITY_DETAILS_FAILURE =
    'EQUITY: SAVE_EQUITY_DETAILS_FAILURE';
export const UPDATE_CONSIGNMENT_DETAILS =
    'CONSIGNMENT: UPDATE_CONSIGNMENT_DETAILS';
export const UPDATE_CONSIGNMENT_DETAILS_SUCCESS =
    'CONSIGNMENT: UPDATE_CONSIGNMENT_DETAILS_SUCCESS';
export const UPDATE_CONSIGNMENT_DETAILS_FAILURE =
    'CONSIGNMENT: UPDATE_CONSIGNMENT_DETAILS_FAILURE';
export const RESET_CREATE_UPDATE_CONSIGNMENT =
    'RESET_CREATE_UPDATE_CONSIGNMENT';
export const VALIDATE_ACCOUNT = 'BILLING: VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS = 'BILLING: VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNTS_FAILURE = 'BILLING: VALIDATE_ACCOUNT_FAILURE';
export const RESET_VALIDATE_ACCOUNT = 'BILLING_RESET_VALIDATE_ACCOUNT';
export const STORE_ITEM_TABLE_DATA = 'CONSIGNMENT: STORE_ITEM_TABLE_DATA';
export const SET_ALL_ACCOUNT_OWNED_SELECTED =
    'CONSIGNMENT: SET_ALL_ACCOUNT_OWNED_SELECTED';
export const RESET_VALIDATED_DATA = 'CONSIGNMENT: RESET_VALIDATED_DATA';
export const GET_PRICES_FOR_ITEMS = 'CONSIGNMENT: GET_PRICES_FOR_ITEMS';
export const GET_PRICES_FOR_ITEMS_SUCCESS =
    'CONSIGNMENT: GET_PRICES_FOR_ITEMS_SUCCESS';
export const GET_PRICES_FOR_ITEMS_FAILURE =
    'CONSIGNMENT: GET_PRICES_FOR_ITEMS_FAILURE';
export const GET_CONSIGNMENT_DETAILS = 'CONSIGNMENT: GET_CONSIGNMENT_DETAILS';
export const GET_CONSIGNMENT_DETAILS_SUCCESS =
    'CONSIGNMENT: GET_CONSIGNMENT_DETAILS_SUCCESS';
export const GET_CONSIGNMENT_DETAILS_FAILURE =
    'CONSIGNMENT: GET_CONSIGNMENT_DETAILS_FAILURE';
export const RESET_CONSIGNMENT_MYCASEREF_REFERENCE =
    'CONSIGNMENT: RESET_CONSIGNMENT_MYCASEREF_REFERENCE';
export const GET_USAGE_DETAILS = 'CONSIGNMENT: GET_USAGE_DETAILS';
export const GET_USAGE_DETAILS_SUCCESS =
    'CONSIGNMENT: GET_USAGE_DETAILS_SUCCESS';
export const GET_USAGE_DETAILS_FAILURE =
    'CONSIGNMENT: GET_USAGE_DETAILS_FAILURE';
export const SET_UNSAVED_CHANGES_POP_UP =
    'CONSIGNMENT:SET_UNSAVED_CHANGES_POP_UP';
export const SET_CONSIGNMENT_CU_IN_PROGRESS =
    'CONSIGNMENT:SET_CONSIGNMENT_CU_IN_PROGRESS';
export const SET_ROUTE_PATH_FOR_CONSIGNMENT_UNSAVED_CHANGES_POP_UP =
    'CONSIGNMENT:SET_ROUTE_PATH_FOR_CONSIGNMENT_UNSAVED_CHANGES_POP_UP';
export const GET_INVENTORY_DATA = 'CONSIGNMENT:GET_INVENTORY_DATA';
export const GET_INVENTORY_DATA_SUCCESS =
    'CONSIGNMENT:GET_INVENTORY_DATA_SUCCESS';
export const GET_INVENTORY_DATA_FAILURE =
    'CONSIGNMENT:GET_INVENTORY_DATA_FAILURE';
export const SET_QUANTITY_VALIDATION = 'CONSIGNMENT:SET_QUANTITY_VALIDATION';
export const SET_PRICE_OVERRIDE_DETAILS = 'SET_PRICE_OVERRIDE_DETAILS';
export const SET_PRICE_OVERRIDE = 'SET_PRICE_OVERRIDE';
export const RESET_ITEMTABLE_DATA = 'RESET_ITEMTABLE_DATA';
export const USAGE_ATTACHMENT_UPLOAD =
    'CONSIGNMENT: CONSIGNMENT_ATTACHMENT_UPLOAD';
export const USAGE_ATTACHMENT_UPLOAD_SUCCESS =
    'CONSIGNMENT: CONSIGNMENT_ATTACHMENT_UPLOAD_SUCCESS';
export const RESET_PO_ATTACHMENT = 'CONSIGNMENT:RESET_PO_ATTACHMENT';
export const USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE =
    'CONSIGNMENT: CONSIGNMENT_ATTACHMENT_UPLOAD_SUCCESS_TISSUE';
export const USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE =
    'CONSIGNMENT: CONSIGNMENT_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE';
export const USAGE_ATTACHMENT_UPLOAD_FAILURE =
    'CONSIGNMENT: CONSIGNMENT_ATTACHMENT_UPLOAD_FAILURE';
export const GET_IMAGE_PO_PREVIEW = 'CONSIGNMENT: GET_IMAGE_PO_PREVIEW';
export const GET_IMAGE_PO_PREVIEW_SUCCESS =
    'CONSIGNMENT: GET_IMAGE_PO_PREVIEW_SUCCESS';
export const GET_IMAGE_PO_PREVIEW_FAILURE =
    'CONSIGNMENT: GET_IMAGE_PO_PREVIEW_FAILURE';
export const DELETE_ATTACHMENT_REQUEST =
    'CONSIGNMENT: DELETE_ATTACHMENT_REQUEST';
export const DELETE_ATTACHMENT_REQUEST_SUCCESS =
    'CONSIGNMENT: DELETE_ATTACHMENT_REQUEST_SUCCESS';
export const DELETE_ATTACHMENT_REQUEST_FAILURE =
    'CONSIGNMENT: DELETE_ATTACHMENT_REQUEST_FAILURE';
export const SHOW_HIDE_CONSIGNMENT_FOOTER =
    'CONSIGNMENT: SHOW_HIDE_CONSIGNMENT_FOOTER';
export const CHECK_IS_PRICEOVERRIDE_PAGE =
    'CONSIGNMENT: CHECK_IS_PRICEOVERRIDE_PAGE';
export const CHECK_IS_PRODUCT_VALIDATION =
    'CONSIGNMENT: CHECK_IS_PRODUCT_VALIDATION';
export const VALIDATE_PRODUCT_DETAILS = 'CONSIGNMENT: VALIDATE_PRODUCT_DETAILS';
export const VALIDATE_PRODUCT_DETAILS_SUCCESS =
    'CONSIGNMENT: VALIDATE_PRODUCT_DETAILS_SUCCESS';
export const VALIDATE_PRODUCT_DETAILS_FAILURE =
    'CONSIGNMENT: VALIDATE_PRODUCT_DETAILS_FAILURE';
// get derived territories (non-interventional)
export const GET_DERIVED_TERRITORIES = 'CONSIGNMENT_BILLING: GET_DERIVED_TERRITORIES';
export const SET_DERIVED_TERRITORIES_SUCCESS =
    'CONSIGNMENT_BILLING: SET_DERIVED_TERRITORIES_SUCCESS';
export const SET_DERIVED_TERRITORIES_FAILURE =
    'CONSIGNMENT_BILLING: SET_DERIVED_TERRITORIES_FAILURE';
export const SAVE_CONSIGNMENT_ORDER = 'CONSIGNMENT: SAVE_CONSIGNMENT_ORDER';
export const SAVE_CONSIGNMENT_DETAILS = 'CONSIGNMENT: SAVE_CONSIGNMENT_DETAILS';
export const SAVE_CONSIGNMENT_DETAILS_SUCCESS =
    'CONSIGNMENT: SAVE_CONSIGNMENT_DETAILS_SUCCESS';
export const SAVE_CONSIGNMENT_DETAILS_FAILURE =
    'CONSIGNMENT: SAVE_CONSIGNMENT_DETAILS_FAILURE';

export const PRICE_OVERRIDE_REASON = 'CONSIGNMENT: PRICE_OVERRIDE_REASON';
export const CEAR_PRICE_OVER_RIDE = 'CEAR_PRICE_OVER_RIDE';
export const SET_CONSIGNMENT_ORDER_SUBMITTED =
    'CONSIGNMENT: SET_CONSIGNMENT_ORDER_SUBMITTED';
export const RESET_IS_FOR_REPLEN = 'CONSIGNMENT: RESET_IS_FOR_REPLEN';
export const SET_PAYMENT_DETAILS = 'CONSIGNMENT: SET_PAYMENT_DETAILS';
export const SET_PRICEOVERRIDE_BTN = 'CONSIGNMENT:SET_PRICEOVERRIDE_BTN';
export const SET_PRICEITEM_BTN = 'CONSIGNMENT:SET_PRICEITEM_BTN';
export const CHECK_IS_BACK_FROM_INVENTORY =
    'CONSIGNMENT:CHECK_IS_BACK_FROM_INVENTORY';
export const RESET_IS_FOR_PRICEOVERRIDE =
    'CONSIGNMENT:RESET_IS_FOR_PRICEOVERRIDE';
export const SET_ITEMS_DURING_PRICING = 'CONSIGNMENT:SET_ITEMS_DURING_PRICING';
export const CLEAR_SHIPPING_METHODS = 'CONSIGNMENT:CLEAR_SHIPPING_Methods';
export const DELETE_PRICED_ITEMS = 'CONSIGNMENT:DELETE_PRICED_ITEMS';
export const RESET_PRICES_FOR_ITEMS = 'CONSIGNMENT:RESET_PRICES_FOR_ITEMS';
export const SET_INVENTORY_ITEMS_DETAILS =
    'CONSIGNMENT:SET_INVENTORY_ITEMS_DETAILS';
export const PRICE_OVERRIDE_NOTES = 'CONSIGNMENT:PRICE_OVERRIDE_NOTES';
export const SET_SURGERY_NUMBER = 'CONSIGNMENT: SET_SURGERY_NUMBER';
export const GET_TRANSFER_RECIPIENT_METHODS =
    'BILL : GET_TRANSFER_RECIPIENT_METHODS';
export const GET_TRANSFER_RECIPIENT_METHODS_SUCCESS =
    'BILL : GET_TRANSFER_RECIPIENT_METHODS_SUCCESS';
export const GET_TRANSFER_RECIPIENT_METHODS_FAILURE =
    'BILL : GET_TRANSFER_RECIPIENT_METHODS_FAILURE';
export const CLEAR_TRANSFER_RECIPIENTS = 'BILL: CLEAR_TRANSFER_RECIPIENTS';
export const SET_REPLENISHMENT_SURGERY_NUMBER =
    'BILL:SET_REPLENISHMENT_SURGERY_NUMBER';
export const VALIDATE_REPLEN_SUCCESS = 'BILL:VALIDATE_REPLEN_SUCCESS';
export const VALIDATE_REPLEN_FAILURE = 'BILL:VALIDATE_REPLEN_FAILURE';
export const VALIDATE_REPLEN = 'BILL:VALIDATE_REPLEN';
export const CLEAR_VALIDATE_REPLEN = 'BILL:CLEAR_VALIDATE_REPLEN';
export const CLEAR_ERROR = 'BILL:CLEAR_ERROR';
export const SET_COPY_ITEM_TABLE_DATA='SET_COPY_ITEM_TABLE_DATA';
export const SET_RECIPIENTS = 'SET_RECIPIENTS';
export const CLEAR_CONSIGNMENT_SHIP_TO_ADDRESS =
    'CONSIGNMENTBILLINGSHIPPING: CLEAR_CONSIGNMENT_SHIP_TO_ADDRESS';

export const createItemTableCopy = (items,pricingNotes,priceOverrideReason) => {
    return {
        type: SET_COPY_ITEM_TABLE_DATA,
        payload: {items,pricingNotes,priceOverrideReason},
    };
};
export const saveConsignmentOrder = (payload) => {
    return { type: SAVE_CONSIGNMENT_ORDER, payload: payload };
};
export const setSurgeryNumber = (numberOfSurgeries) => {
    return {
        type: SET_SURGERY_NUMBER,
        payload: numberOfSurgeries,
    };
};
export const setReplenishmentSurgeryNumber = (numberOfSurgeries) => {
    return {
        type: SET_REPLENISHMENT_SURGERY_NUMBER,
        payload: numberOfSurgeries,
    };
};
export const setFooterDisplay = (data) => {
    return { type: SHOW_HIDE_CONSIGNMENT_FOOTER, payload: data };
};

export const setPriceOverridePage = (data) => {
    return { type: CHECK_IS_PRICEOVERRIDE_PAGE, payload: data };
};

export const setSurgeryDetails = (surgeryDetails) => {
    return { type: SET_SURGERY_DETAILS, payload: surgeryDetails };
};

//
export const saveSurgery = (surgeryDetails) => {
    return { type: SAVE_SURGERY_DETAILS, payload: surgeryDetails };
};

export const updateSurgery = (surgeryDetails) => {
    return { type: UPDATE_SURGERY_DETAILS, payload: surgeryDetails };
};

export const applyShipToAdderess = (shippingDetails) => {
    return { type: SET_SHIP_TO_ADDRESS_DETAILS, payload: shippingDetails };
};

export const setCartData = (cartData) => {
    return { type: SET_CART_DATA, payload: cartData };
};

export const updateCartData = (operation, productKey, isSet) => {
    return {
        type: UPDATE_CART_DATA,
        payload: {
            operation,
            productKey,
            isSet,
        },
    };
};

export const updateCartDataShipping = (newFields, productKeys) => {
    return {
        type: UPDATE_CART_DATA_SHIPPING,
        payload: {
            newFields,
            productKeys,
        },
    };
};

export const setShippingDetails = (shippingDetails) => {
    return { type: SET_SHIPPING_DETAILS, payload: shippingDetails };
};

export const setShippingDetailsEditMode = (shippingDetails) => {
    return { type: SET_SHIPPING_DETAILS_EDIT_MODE, payload: shippingDetails };
};

export const getDropdownValues = (dropDownDetails) => {
    return { type: GET_DROPDOWN, payload: dropDownDetails };
};
export const setProductsGuide = (productsGuideList, name) => {
    return { type: SET_PRODUCTSGUIDE, payload: productsGuideList, name: name };
};

export const searchProducts = (queryParam) => {
    return { type: GET_PRODUCTS, payload: queryParam };
};

export const searchProductsBulk = (cfns) => {
    return { type: GET_PRODUCTS_BULK, payload: cfns };
};

export const clearProducts = () => {
    return { type: CLEAR_PRODUCTS };
};

export const getProductsGuide = () => {
    return { type: GET_PRODUCTSGUIDE };
};

export const sortProductDetails = (data) => {
    return { type: SORT_PRODUCT_DETAILS, payload: data };
};
export const setProgressBarStatus = (completedStep) => {
    return { type: SET_PROGRESS_BAR_STATUS, payload: completedStep };
};

export const reSetProgressBarStatus = () => {
    return { type: RESET_PROGRESS_BAR_STATUS };
};

export const setProgressBarCurrentStep = (currentStep) => {
    return { type: SET_PROGRESS_BAR_CURRENT_STEP, payload: currentStep };
};

export const setProgressBarStateEditMode = (data) => {
    return { type: SET_PROGRESS_BAR_EDIT_MODE, payload: data };
};

export const validateProducts = (products) => {
    return { type: VALIDATE_PRODUCTS, payload: products };
};

export const clearValidatedProducts = () => {
    return { type: CLEAR_VALIDATED_PRODUCTS };
};

export const getProductDetails = (data) => {
    return { type: GET_PRODUCT_DETAILS, payload: data };
};

export const getProductsTemplatesFilter = () => {
    return { type: GET_PRODUCTSTEMPLATESFILTER };
};

export const setProductsTemplatesFilter = (productsTemplatesFilter) => {
    return {
        type: SET_PRODUCTSTEMPLATESFILTER,
        payload: productsTemplatesFilter,
    };
};

export const getShippingMethods = (payload) => {
    return { type: GET_SHIPPING_METHODS, payload };
};

export const getShipToAddress = (searchValue) => { 
    return { type: GET_SHIP_TO_ADDRESS, payload: searchValue};
};

export const getShippingBatchAllocations = (cfn) => {
    return { type: GET_BATCH_ALLOCATIONS, payload: cfn };
};
export const handleSurgeryNotes = (data) => {
    return { type: HANDLE_SURGERY_NOTES, payload: data };
};
export const setPricingNotes = (data) => {
    return { type: SET_PRICING_NOTES, payload: data };
};
export const setPriceOverrideNotes = (data) => {
    return { type: PRICE_OVERRIDE_NOTES, payload: data };
};
export const setVisualizationInspection = (value) => {
    return { type: SET_VISUALIZATION_INSPECTION, payload: value };
};
export const getSurgeryDetails = (myCaseRef, updateState) => {
    return {
        type: GET_SURGERY_DETAILS,
        payload: {
            myCaseRef,
            updateState,
        },
    };
};
export const clearConsignmentShipToAddress = () => {
    return { type: CLEAR_CONSIGNMENT_SHIP_TO_ADDRESS };
};


export const resetSurgeryDetails = () => {
    return { type: RESET_SURGERY_DETAILS, payload: '' };
};
export const changeShippingSegmentIndex = (index) => {
    return { type: CHANGE_SHIPPING_SEGMENT_INDEX, payload: index };
};
export const changeAcknowlegmentCheckbox = (data) => {
    return { type: CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT, payload: data };
};
export const changeAcknowlegmentView = (data) => {
    return { type: CHANGE_ACKNOWLEGMENT_VIEW, payload: data };
};
export const disableSurgeryDate = (value) => {
    return { type: DISABLE_SURGERY_DATE, payload: value };
};
export const currentSurgeryDateSelected = (value) => {
    return { type: CURRENT_SURGERY_DATE_SELECTED, payload: value };
};

export const getProductsCategoryAndBrands = (data) => {
    return { type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA, payload: data };
};

export const getProductsByBrandOrSuperCategory = (data) => {
    return { type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY, payload: data };
};

export const setScheduleSurgeryUnsavedChangesPopUp = (value) => {
    return { type: SET_UNSAVED_CHANGES_POP_UP, payload: value };
};
export const setScheduleSurgeryCUInProgress = (value) => {
    return { type: SET_SCHEDULE_SURGERY_CU_IN_PROGRESS, payload: value };
};
export const loadAllPhyscianLoading = (data) => {
    return { type: PHYSICIAN_LOAD_ALL_LOADING, payload: data };
};
export const putRecentlyUsedPhysicians = (physicianId) => {
    return { type: PUT_RECENTLY_USED_PHYSICIANS, payload: physicianId };
};
export const setRoutePathForSSUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_SS_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const getDerivedTerritories = (value) => {
    return { type: GET_DERIVED_TERRITORIES, payload: value };
};

export const getDetailedProductTemplateList = (params) => {
    return { type: GET_DETAILED_PRODUCT_TEMPLATE_LIST, payload: params };
};

export const getTemplateDetails = (params) => {
    return { type: GET_TEMPLATE_DETAILS, payload: params };
};

export const createTemplate = (params) => {
    return { type: CREATE_PRODUCT_TEMPLATE, payload: params };
};

export const resetCreateTemplate = () => {
    return { type: RESET_CREATE_TEMPLATE };
};

export const updateProductTemplate = (params) => {
    return { type: UPDATE_PRODUCT_TEMPLATE, payload: params };
};

export const getRequiredDataFromOrder = (params) => {
    return { type: GET_DATA_FOR_PRODUCT_TEMPLATE, payload: params };
};

export const clearSingleDropDownList = (value) => {
    return { type: CLEAR_SPECFIC_DROPDOWN_LIST, payload: value };
};
export const getHolidayList = (data) => {
    return { type: GET_HOLIDAY_LIST, payload: data };
};
export const clearShippingAddress = (data) => {
    return { type: CLEAR_SHIPPING_ADDRESS, payload: data };
};
export const resetCreateOrUpdateSurgery = () => {
    return { type: RESET_CREATE_UPDATE_SURGERY };
};

export const setExpandedFilters = (data) => {
    return { type: SET_EXPANDED_FILTER_VIEW, payload: data };
};

export const clearProductsGuide = () => {
    return { type: CLEAR_PRODUCTS_GUIDE };
};

export const getEquityDetails = (params) => {
    return { type: GET_EQUITY_DETAILS, payload: params };
};

export const saveEquity = (equityDetails) => {
    return { type: SAVE_EQUITY_DETAILS, payload: equityDetails };
};

export const saveConsignment = (consignmentDetails) => {
    return { type: SAVE_CONSIGNMENT_DETAILS, payload: consignmentDetails };
};

export const updateConsignment = (consignmentDetails) => {
    return { type: UPDATE_CONSIGNMENT_DETAILS, payload: consignmentDetails };
};

export const getValidateAccountDetails = (params) => {
    return { type: VALIDATE_ACCOUNT, payload: params };
};

export const resetValidateAccountDetails = () => {
    return {
        type: RESET_VALIDATE_ACCOUNT,
    };
};

export const storeItemTableData = (itemTableData) => {
    return { type: STORE_ITEM_TABLE_DATA, payload: itemTableData };
};

export const setAllAccountOwned = (value) => ({
    type: SET_ALL_ACCOUNT_OWNED_SELECTED,
    payload: value,
});

export const resetValidatedData = () => ({ type: RESET_VALIDATED_DATA });

export const getConsignmentDetails = (params) => {
    return { type: GET_CONSIGNMENT_DETAILS, payload: params };
};

export const resetConsignmentMyCaseRefReference = () => ({
    type: RESET_CONSIGNMENT_MYCASEREF_REFERENCE,
});

export const fetchUsageDetailsRequest = (queryParams) => ({
    type: GET_USAGE_DETAILS,
    payload: queryParams,
});

export const setRoutePathForConsignmentUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_CONSIGNMENT_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};
export const setConsignmentUnsavedChangesPopUp = (value) => {
    return { type: SET_UNSAVED_CHANGES_POP_UP, payload: value };
};
export const setConsignmentCUInProgress = (value) => {
    return { type: SET_CONSIGNMENT_CU_IN_PROGRESS, payload: value };
};

export const getInventoryDetails = (payload) => {
    return { type: GET_INVENTORY_DATA, payload: payload };
};

export const setQuantityValidation = (payload) => {
    return { type: SET_QUANTITY_VALIDATION, payload: payload };
};

export const setPriceOverrideDetails = (value) => {
    return { type: SET_PRICE_OVERRIDE_DETAILS, payload: value };
};

export const setPriceOverride = (value) => {
    return { type: SET_PRICE_OVERRIDE, payload: value };
};

export const resetItemTableData = () => {
    return { type: RESET_ITEMTABLE_DATA, payload: '' };
};

export const usageAttachmentUpload = (formData) => ({
    type: USAGE_ATTACHMENT_UPLOAD,
    payload: formData,
});

export const getPoImagePreview = (details) => {
    return { type: GET_IMAGE_PO_PREVIEW, payload: details };
};

export const resetPoDetails = () => ({
    type: RESET_PO_ATTACHMENT,
    payload: '',
});

export const setPOTissueImageDetails = (data) => {
    return { type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE, payload: data };
};

export const setPONonTissueImageDetails = (data) => {
    return { type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE, payload: data };
};

export const deleteAttachmentRequest = (id) => ({
    type: DELETE_ATTACHMENT_REQUEST,
    payload: id,
});

export const validateProductDetails = (
    reqBody,
    isForReplen,
    isForPriceOverride
) => ({
    type: VALIDATE_PRODUCT_DETAILS,
    payload: {
        reqBody,
        isForReplen,
        isForPriceOverride,
    },
});

export const setProductValidationInProgress = (data) => {
    return { type: CHECK_IS_PRODUCT_VALIDATION, payload: data };
};

export const setPriceOverrideReason = (data) => {
    return { type: PRICE_OVERRIDE_REASON, payload: data };
};

export const setConsignmentOrderSubmitted = (isSubmitted) => ({
    type: SET_CONSIGNMENT_ORDER_SUBMITTED,
    payload: isSubmitted,
});

export const resetConsignmentSubmittedData = () => {
    return { type: RESET_CREATE_UPDATE_CONSIGNMENT };
};

export const clearPriceOverRide = () => {
    return { type: CEAR_PRICE_OVER_RIDE };
};
export const resetIsForReplen = (payload) => {
    return { type: RESET_IS_FOR_REPLEN, payload: payload };
};

export const storePaymentDetails = (paymentDetails) => {
    return { type: SET_PAYMENT_DETAILS, payload: paymentDetails };
};

export const getInventoryCheckedItems = (checkedItems) => {
    return { type: GET_INVENTORY_CHECKED_ITEMS, payload: checkedItems };
};

export const setIsButtonDisabled = (data) => {
    return { type: SET_PRICEOVERRIDE_BTN, payload: data };
};

export const setPriceItemButtonDisabled = (data) => {
    return { type: SET_PRICEITEM_BTN, payload: data };
};

export const checkIsBackFromInventory = (data) => {
    return { type: CHECK_IS_BACK_FROM_INVENTORY, payload: data };
};

export const resetIsForPriceOverride = (payload) => {
    return { type: RESET_IS_FOR_PRICEOVERRIDE, payload: payload };
};
export const getPricesForConsignmentItems = (priceItemsObj) => ({
    type: GET_PRICES_FOR_ITEMS,
    payload: priceItemsObj,
});

export const resetItemPrices = () => {
    return { type: RESET_PRICES_FOR_ITEMS };
};
export const setInventoryItems = (checkedItems) => {
    return { type: SET_INVENTORY_ITEMS_DETAILS, payload: checkedItems };
};

export const resetDetailsDropdownReducer = () => {
    return { type: RESET_CONSIGNMENT_DETAILS };
};

export const resetPriceOverrideDetails = () => {
    return { type: RESET_PRICEOVERRIDE_DATA };
};

export const getTransferRecipientMethods = (payload) => {
    return {
        type: GET_TRANSFER_RECIPIENT_METHODS,
        payload,
    };
};

export const clearTransferRecipients = (data) => {
    return {
        type: CLEAR_TRANSFER_RECIPIENTS,
    };
};

export const clearValidateReplenData = () => ({
    type: CLEAR_VALIDATE_REPLEN,
});

export const validatedReplenData = (products) => ({
    type: VALIDATE_REPLEN,
    payload: products,
});
export const clearError = () => ({
    type: CLEAR_ERROR,
});

export const setRecipients = (recipients) => {
    return {
        type: SET_RECIPIENTS,
        payload: recipients,
    };
};